/* VoltBy - the cart shows the buyer's own design.

   A generator order is one product for every buyer, so the cart used to show
   the same stock picture on every line - or, for the matching pieces, nothing
   at all. The buyer's actual design is already in this browser: the generator
   keeps each one in localStorage (vbig-designs-v1) with the id the cart line
   carries as _generation_id. So the invitation line gets that picture, and a
   pack line gets the photographed mockup of its own set, which the Worker's
   status endpoint hands out for a suite id.

   The swap only happens once the new picture has actually loaded, so a design
   that has expired or a link that fails leaves the product image in place
   rather than an empty square.

   It also hides the "Download" and "Download link" lines on the cart page.
   They exist so the link survives into the order confirmation email, but in
   the cart they are just two long Worker URLs under the product name, and
   the files are not paid for yet. Checkout and the email still show them.

   Rows are matched by position: Dawn numbers them CartItem-N (cart page) and
   CartDrawer-Item-N (drawer), N = index + 1, in the same order as /cart.js. */
(function () {
  if (window.__vbigCartImg) return;
  window.__vbigCartImg = true;
  if (!window.fetch || !window.MutationObserver) return;

  var WORKER = 'https://voltby-generator.chakk-unes.workers.dev';
  var MOCKS = 'vbig-cart-mock-v1';

  function designUrl(gid) {
    try {
      var l = JSON.parse(localStorage.getItem('vbig-designs-v1') || '[]') || [];
      for (var i = 0; i < l.length; i++) if (l[i] && l[i].id === gid && l[i].url) return l[i].url;
    } catch (e) {}
    return '';
  }

  /* one status call per set per visit; the answer is cached for the tab */
  function mocks() { try { return JSON.parse(sessionStorage.getItem(MOCKS) || '{}') || {}; } catch (e) { return {}; } }
  function remember(sid, u) { try { var o = mocks(); o[sid] = u; sessionStorage.setItem(MOCKS, JSON.stringify(o)); } catch (e) {} }
  var asking = {};
  function mockup(sid) {
    var known = mocks()[sid];
    if (typeof known === 'string') return Promise.resolve(known);
    if (asking[sid]) return asking[sid];
    asking[sid] = fetch(WORKER + '/suite/status?suite_id=' + encodeURIComponent(sid), { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { var u = (j && j.mockup_url) || ''; remember(sid, u); return u; })
      .catch(function () { return ''; });
    return asking[sid];
  }

  function swap(img, url, kind) {
    if (!img || !url || img.getAttribute('data-vb-src') === url) return;
    var probe = new Image();
    probe.onload = function () {
      if (!probe.naturalWidth) return;
      img.setAttribute('data-vb-src', url);
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = url;
      /* an invitation is a 5x7 card: show all of it rather than crop its
         header off; a set mockup is square and fills the tile */
      img.style.objectFit = kind === 'inv' ? 'contain' : 'cover';
      if (kind === 'inv') img.style.background = '#F3EDFF';
    };
    probe.src = url;
  }

  function hideLinks(row) {
    var opts = row.querySelectorAll('.product-option');
    for (var i = 0; i < opts.length; i++) {
      var dd = opts[i].querySelector('dd');
      if (dd && dd.textContent.indexOf('workers.dev') !== -1) opts[i].style.display = 'none';
    }
  }

  var busy = false, again = false;
  function run() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        items.forEach(function (it, i) {
          var p = it.properties || {};
          var gid = p._generation_id, sid = p._suite_id;
          if (!gid && !sid) return;
          [document.getElementById('CartItem-' + (i + 1)),
           document.getElementById('CartDrawer-Item-' + (i + 1))].forEach(function (row) {
            if (!row) return;
            hideLinks(row);
            var img = row.querySelector('.cart-item__image');
            if (!img) return;
            if (sid) mockup(sid).then(function (u) { swap(img, u, 'pack'); });
            else swap(img, designUrl(gid), 'inv');
          });
        });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; setTimeout(run, 60); }
      });
  }

  /* the cart re-renders its rows after every change; follow it */
  var t = null;
  function soon() { clearTimeout(t); t = setTimeout(run, 150); }
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var n = ms[i].target;
      if (n && n.closest && (n.closest('#main-cart-items') || n.closest('#CartDrawer'))) { soon(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState !== 'loading') soon();
  else document.addEventListener('DOMContentLoaded', soon);
})();
